<template>
  <ExActionsPopUp
    :value="show"
    headline="Archive Checkpoint"
    :icon="'org_icon_checkpoint'"
    :htmlInfo="info"
    :destructive="true"
    actionLabel="Archive"
    :centerHeadline="true"
    actionsTopSpacing="32px"
    @onAction="$emit('onArchive')"
    @input="$emit('onClose')"
    data-testid="archive-checkpoint-popup"
    :backgroundPatternBottomRight="true"
    :applyBorderClass="true"
    :width="500"
  >
  </ExActionsPopUp>
</template>
<script setup>
import { computed } from "vue";
import ExActionsPopUp from "@components/common/ExActionsPopUp.vue";

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  prefix: {
    type: String,
    default: "",
  },
  name: {
    type: String,
    default: "",
  },
});

defineEmits(["onArchive", "onClose"]);

const formatPrefixDisplay = (prefix) => {
  if (!prefix) return "";
  const normalized = String(prefix).toLowerCase();
  return normalized.charAt(0).toUpperCase() + normalized.slice(1);
};

const checkpointDisplayName = computed(() => {
  return [formatPrefixDisplay(props.prefix), props.name].filter(Boolean).join(" ").trim();
});

const formattedInfo = computed(() => {
  return `<div style="max-width: 260px; margin: 0 auto; margin-top: 26px;">You are about to archive checkpoint ${checkpointDisplayName.value}.</div>`;
});

const info = computed(() => {
  return formattedInfo.value;
});
</script>
